import React from 'react'

const ErrorLog = () => {
  return (
    <div>ErrorLog</div>
  )
}

export default ErrorLog
